import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { BonusesItem } from '../../../models/PaymentHistory';
import { useDateLocalization } from '../../../hooks/useDateLocalization';
import { CustomNumberFormat } from '../../commons/CustomNumberFormat';

interface BonusesCellProps {
  element: BonusesItem;
}

export const BonusesCell: FC<BonusesCellProps> = ({ element }) => {
  const { t } = useTranslation();
  const { formatDate } = useDateLocalization();
  const isMobile = useMediaQuery('(max-width:767px)');

  const getClassBorder = (typeId: number) => {
    const mappedTitles = {
      1: 'mobile-cell__status top-up',
      2: 'mobile-cell__status refund',
      3: 'mobile-cell__status pay',
      4: 'mobile-cell__status pay',
    };
    return mappedTitles?.[typeId];
  };

  return (
    <div className="mobile-cell">
      <div className={getClassBorder(element.TypeID) || `mobile-cell__status`} />
      <div className="mobile-cell__container">
        <div className="mobile-cell__container__title">
          <p>{element.Type}</p>
          {isMobile ? (
            <div className="tooltip">
              <p>
                {element.Amount > 0 && '+'}
                <CustomNumberFormat value={element.Amount} suffix="B" />
              </p>
            </div>
          ) : null}
        </div>
        {element?.Service?.id ? (
          <div className="mobile-cell__container__details">
            <div className="mobile-cell__container__details__services">
              <span className="service-name">{element?.Service?.Name}</span>
            </div>
          </div>
        ) : (
          (element.TypeID === 2 || element.TypeID === 3) && (
            <div className="mobile-cell__container__details">
              <div className="mobile-cell__container__details__services">
                {element.TypeID === 2 ? (
                  <span className="service-name">{t('paymentHistory.supportFix')}</span>
                ) : undefined}
                {element.TypeID === 3 ? (
                  <span className="service-name">{t('paymentHistory.expireBonuses')}</span>
                ) : undefined}
              </div>
            </div>
          )
        )}
        {isMobile ? (
          <div className="mobile-cell__container__pay-date">
            <span className="title">{t('paymentHistory.operationDate')}</span>
            <span>
              {formatDate(element?.CreateDate)}{' '}
              {formatDate(element?.CreateDate, { hour: 'numeric', minute: 'numeric' })}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
};
